// The questions shoppers ask before buying a fragrance, answered on the page
// and marked up for semantic clarity, without promising a search feature.
export const PERFUME_FAQ = [
  {
    q: "Do you carry Lattafa perfumes in Puerto Rico?",
    a: "We list Lattafa fragrances when they are in our available inventory. Check each product photo and description, and contact the store directly for packaging or authenticity questions before ordering.",
  },
  {
    q: "Are Arabic perfumes long lasting?",
    a: "Longevity varies by fragrance, concentration, skin and climate. Many Arabic fragrances feature oud, amber and musk, but check the notes on the specific product before choosing.",
  },
  {
    q: "Where do I pick up my order in Puerto Rico?",
    a: "Choose pickup or request local delivery at checkout, then share your preferred location. The store will confirm stock, pickup or delivery arrangements, and payment instructions on WhatsApp.",
  },
  {
    q: "Do you carry colognes and perfumes for women?",
    a: "The catalog leans toward men's Arabic colognes, with unisex fragrances that wear well on anyone. If you are after a specific women's scent, ask and it can be requested.",
  },
  {
    q: "Which payment methods are available?",
    a: "You can choose ATH Móvil, PayPal, Cash App, Venmo or cash as your preferred payment method. No automatic online charge is made; payment details are confirmed directly by the store.",
  },
  {
    q: "Can I search by scent, brand or price?",
    a: "Yes. Type a name, brand or note such as oud or vanilla into the search field, then narrow the catalog by brand, fragrance type, price and availability.",
  },
];

export default function PerfumeFaq() {
  return (
    <section className="border-t border-white/10 pb-16 pt-12 sm:pt-16" aria-labelledby="perfumeria-faq">
      <h2 id="perfumeria-faq" className="font-display text-3xl font-medium tracking-[-.05em] sm:text-4xl">
        Fragrance questions, answered.
      </h2>
      <div className="mt-6 divide-y divide-white/10 border-y border-white/10">
        {PERFUME_FAQ.map((item) => (
          <details key={item.q} className="group py-4">
            <summary className="flex cursor-pointer items-start justify-between gap-4 text-sm font-semibold text-[#f4efe6] marker:content-none [&::-webkit-details-marker]:hidden">
              <span>{item.q}</span>
              <span aria-hidden="true" className="mt-0.5 shrink-0 text-[#c5e5f1] transition group-open:rotate-45">+</span>
            </summary>
            <p className="mt-3 max-w-[62ch] text-sm leading-7 text-white/55">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}